var _effectorFileName = "/builds/gmini/front-common/src/helpers/getModulesLinkFromEnv.ts";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
export var getModulesLinkFromEnv = function getModulesLinkFromEnv(envLinks, projectUrn, projectType) {
  var links = JSON.parse(envLinks);
  var gStationModules = [{
    id: 1,
    name: 'G-Station',
    url: links.gs ? "https://".concat(links.gs).concat(projectUrn && projectType === 'GStation' ? "/dm/projects/".concat(projectUrn) : '') : ''
  }].filter(function (module) {
    return module.url;
  });
  var ourModules = [{
    id: 1,
    name: 'Set-management',
    url: links.sm ? "https://".concat(links.sm).concat(projectUrn ? "?projectUrn=".concat(projectUrn) : '') : ''
  }, {
    id: 2,
    name: 'Объёмы',
    url: links.em ? "https://".concat(links.em).concat(projectUrn ? "?projectUrn=".concat(projectUrn) : '') : ''
  }, {
    id: 3,
    name: 'Проверки',
    url: links.cm ? "https://".concat(links.cm).concat(projectUrn ? "?projectUrn=".concat(projectUrn) : '') : ''
  }, {
    id: 4,
    name: 'Стройконтроль',
    url: links.fm ? "https://".concat(links.fm).concat(projectUrn ? "?projectUrn=".concat(projectUrn) : '') : ''
  }, {
    id: 5,
    name: 'Чек-листы',
    url: links.chm ? "https://".concat(links.chm).concat(projectUrn ? "?projectUrn=".concat(projectUrn) : '') : ''
  }, {
    id: 6,
    name: 'Замечания',
    url: links.ism ? "https://".concat(links.ism).concat(projectUrn ? "?projectUrn=".concat(projectUrn) : '') : ''
  }].filter(function (module) {
    return module.url;
  });
  var otherModules = [{
    id: 1,
    name: 'Тендеры',
    url: links.t ? "https://".concat(links.t) : ''
  }, {
    id: 2,
    name: 'Гранд-тендеры',
    url: links.gt ? "https://".concat(links.gt) : ''
  }, {
    id: 3,
    name: 'Личный кабинет',
    url: links.lk ? "https://".concat(links.lk) : ''
  }].filter(function (module) {
    return module.url;
  });
  return [ourModules, otherModules, gStationModules];
};